import { IonButton } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { registerSW } from "virtual:pwa-register";

export default function PwaUpdatePrompt() {
  const [needsRefresh, setNeedsRefresh] = useState(false);
  const updateServiceWorkerRef = useRef(null);

  useEffect(() => {
    updateServiceWorkerRef.current = registerSW({
      immediate: true,
      onNeedRefresh() {
        setNeedsRefresh(true);
      },
    });
  }, []);

  if (!needsRefresh) {
    return null;
  }

  return (
    <div className="pwa-update-banner" role="status" aria-live="polite">
      <span>New Metora version available.</span>
      <IonButton size="small" onClick={() => updateServiceWorkerRef.current?.(true)}>
        Update
      </IonButton>
    </div>
  );
}
